import { track } from '@fff-web/fff-analytics';
import { REACTIVATE_MEMBERSHIP_LABEL } from '../../../constants';
import { MY_ACCOUNT_EXPERIENCE } from '../../utils/segment';

const CLICK_FOR_REACTIVATION_CTA_NAME = 'Reactivation Started';

const trackClickCancelSubscription = (eventName: string, ctaName: string, cancelType: string) => {
  const properties = {
    cta_name: ctaName,
    experience: MY_ACCOUNT_EXPERIENCE,
    cancel_type: cancelType,
  };
  track({ trackName: eventName, properties }).finally(() => true);
};

const trackClickReactivateMembership = () => {
  const properties = {
    cta_name: REACTIVATE_MEMBERSHIP_LABEL,
    type: 'Expired Member',
    experience: MY_ACCOUNT_EXPERIENCE,
    reactivation_type: 'Expired',
  };
  track({ trackName: CLICK_FOR_REACTIVATION_CTA_NAME, properties }).finally(() => true);
};

export { trackClickCancelSubscription, trackClickReactivateMembership };
